import React from "react";
import ReactDOM from "react-dom";
import BaseComponent from "../../../../baseComponent.js";
import InternalEvent from "../../../../../core/constants/internalEvent.js";
import WidgetTypes from "../../../../../core/constants/widgetType.js";
import UniqueIdGenerator from "../../../../../core/utils/uniqueIdGenerator.js";
import DatasetService from "../../../../../core/services/datasetService.js";
import styles from "./data.scss";



import AddWidget from "../../../../dashboard/add-widget/addWidget.jsx";
import Licenses from "../license/license.jsx";

const donutChartImg = require('file!../../../../../img/demo/Donut.png');
const gaugeChartImg = require('file!../../../../../img/demo/Gauge.png');
const textualChartImg = require('file!../../../../../img/demo/Textual.png');
const barLineChartImg = require('file!../../../../../img/demo/BarLine.png');
const spreadsheetImg = require('file!../../../../../img/demo/spreadsheet.png');

export default class Data extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      fields: [],
      widgetData: null,
      widgetType: WidgetTypes.TIME_SERIES,
      dataProfile: null,
      showRequireSubscription: false
    };
    this.widgetId = UniqueIdGenerator.id();
    this.legends = [];
  }

  componentWillMount() {
    // DatasetService.checkUserDatasetSubscription(this.props.dataset.datasetId)
    //   .then(subscriptions => {
    //     console.log(subscriptions);
    //   });
  }

  componentDidMount() {
    this.init();
    this.subscribe(InternalEvent.Dashboard.WIDGET_SNAPSHOT_LOADED, data => {
      if (data.noSubscriptions.length > 0) {
        ReactDOM.unmountComponentAtNode(document.getElementById("preview-widget"));
        this.setState({showRequireSubscription: true});
      }
      // this.snapshotStatus[data.widgetId] = data.noSubscriptions || [];
      // let notSubscribedDatasets = [];
      // for (let widgetId in this.snapshotStatus) {
      //   if (!this.snapshotStatus[widgetId]) {
      //     return;
      //   } else {
      //     notSubscribedDatasets = notSubscribedDatasets.concat(this.snapshotStatus[widgetId]);
      //   }
      // }
      // console.log(this.snapshotStatus);
      // this.publish(InternalEvent.Dashboard.OPEN_SUBSCRIPTION_POPUP, {map: this.snapshotStatus, notSubscribedDatasets})
    });
  }

  componentWillUnmount() {
    this.unsubscribeAll();
    ReactDOM.unmountComponentAtNode(document.getElementById("preview-widget"));
  }

  init() {
    DatasetService.getDataProfileById(this.props.dataset.dataProfileId, (response) => {
      this.setState({
        fields: response.data[0].fields,
        dataProfile: response.data[0]
      });

      DatasetService.findDatasetWidget(this.props.dataset.datasetId, this.props.dataset.dataProfileId)
        .then(data => {
          let props = {
            dataset: this.props.dataset,
            fields: this.state.fields,
            field: this.state.fields[0],
            widgetData: null,
            dataProfile: this.state.dataProfile,
            isPreviewWidget: true
          };


          if (data) {
            data.widgetState = JSON.parse(data.widgetState);
            this.setState({
              widgetData: data
            });

            props.widgetData = data;

            ReactDOM.render(React.createElement(AddWidget, props), document.getElementById("preview-widget"));
            this.setActiveWidgetIcon(data.widgetState.widgetType);
          } else {
            ReactDOM.render(React.createElement(AddWidget, props), document.getElementById("preview-widget"));
            this.setActiveWidgetIcon(WidgetTypes.TIME_SERIES);
          }
        });
    });
  }

  setActiveWidgetIcon(widgetType) {
    let $componentOptionDivs = $(".preview-component-option");
    let divIndex = 0;
    $componentOptionDivs.removeClass("preview-component-option--active");
    if (widgetType === WidgetTypes.TABLE) {
      divIndex = 0;
    } else if (widgetType === WidgetTypes.GAUGE) {
      divIndex = 1;
    } else if (widgetType === WidgetTypes.TEXTUAL) {
      divIndex = 2;
    } else if (widgetType === WidgetTypes.PIE_CHART) {
      divIndex = 3;
    } else if (widgetType === WidgetTypes.TIME_SERIES) {
      divIndex = 4;
    }
    $($componentOptionDivs[divIndex]).addClass("preview-component-option--active");
  }

  onComponentClick(e) {
    let $currentTarget = $(e.currentTarget);
    let type = $currentTarget.attr("data-type");
    let widgetType;
    $(this.refs.container).find(".preview-component-option--active").removeClass("preview-component-option--active");
    $currentTarget.addClass("preview-component-option--active");

    switch (type) {
      case "TABLE": {
        widgetType = WidgetTypes.TABLE;
        break;
      }
      case "TEXTUAL": {
        widgetType = WidgetTypes.TEXTUAL;
        break;
      }
      case "GAUGE": {
        widgetType = WidgetTypes.GAUGE;
        break;
      }
      case "PIE_CHART": {
        widgetType = WidgetTypes.PIE_CHART;
        break;
      }
      default: {
        widgetType = WidgetTypes.TIME_SERIES;
      }
    }

    this.setState({
      widgetType: widgetType
    });

    this.publish(InternalEvent.Subscription.WIDGET_TYPE_CHANGED, widgetType);
  }

  handleUnsubscribed() {
    this.setState({
      showRequireSubscription: false
    });
    this.init();
  }

  renderContent() {
    if (this.state.showRequireSubscription) {
      return <div className={styles.subscriptions}>
        <div>Require Subscriptions</div>
        <Licenses dataset={this.props.dataset} onSubscribed={this.handleUnsubscribed}/>
      </div>;
    } else {
      return <div style={{display: "flex", flex: 1}}>
        <div className="preview-component-options">
          <div>
            <div className="preview-component-option" data-type="TABLE" onClick={(e) => this.onComponentClick(e)}>
              <img className="preview-component-option__img" src={spreadsheetImg}
                   style={{width: "50px", height: "50px"}}/>
              <div>Table</div>
            </div>
            <div className="preview-component-option" data-type="GAUGE" onClick={(e) => this.onComponentClick(e)}>
              <img className="preview-component-option__img" src={gaugeChartImg}/>
              <div>Gauge</div>
            </div>
            <div className="preview-component-option" data-type="TEXTUAL" onClick={(e) => this.onComponentClick(e)}>
              <img className="preview-component-option__img" src={textualChartImg}
                   style={{width: "72px", height: "32px"}}/>
              <div>Text</div>
            </div>
            <div className="preview-component-option" data-type="PIE_CHART" onClick={(e) => this.onComponentClick(e)}>
              <img className="preview-component-option__img" src={donutChartImg}
                   style={{width: "50px", height: "50px"}}/>
              <div>Donut</div>
            </div>
            <div className="preview-component-option" data-type="TIME_SERIES" onClick={(e) => this.onComponentClick(e)}>
              <img className="preview-component-option__img" src={barLineChartImg} style={{width: "75px"}}/>
              <div>Time Series</div>
            </div>
          </div>
        </div>
        <div id="preview-widget"></div>
      </div>;
    }
  }

  render() {
    return (
      <div className="dataset-detail-data" ref="container">
        {this.renderContent()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/data-bank/dataset-detail/content/data/data.jsx